var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.allPagesLoaded)?[_c('h1',[_vm._v(_vm._s(_vm.pageContent.title.rendered))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageContent.content.rendered)}})]:_c('Loader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }